import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

let infoData = false
export async function info () {
  if (!infoData) infoData = await httpAuth.get(`/acessotela/info`, { tela: 'acesso_tela' })
  return infoData
}

export async function list (filtros) {
  return httpAuth.get(`/acessotela?${serialize(filtros)}`, { tela: 'acesso_tela' })
}

export async function get (id) {
  return httpAuth.get(`/acessotela/${id}`, { tela: 'acesso_tela' })
}

export async function add (dados) {
  return httpAuth.post(`/acessotela`, dados, { funcionalidade: 'acesso_tela_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/acessotela/${id}`, dados, { funcionalidade: 'acesso_tela_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/acessotela/${id}`, { funcionalidade: 'acesso_tela_excluir' })
}
